import { useAuth } from './useAuth';

export function useClientId(): string {
  const { user } = useAuth();
  const clientId = user?.app_metadata?.client_id as string | undefined;
  if (!clientId) {
    throw new Error('Utente senza client_id, contatta admin');
  }
  return clientId;
}
